const testimonials = [
  {
    id: 1,
    name: "John Anderson",

    country: "United States",
    flag: "🇺🇸",
    rating: 5,
    verified: true,
    review: "Outstanding quality, transparent communication and timely delivery. Every shipment has exceeded our expectations and strengthened our long-term business relationship."
  },
  {
    id: 2,
    name: "Emily Carter",

    country: "Canada",
    flag: "🇨🇦",
    rating: 5,
    verified: true,
    review: "Excellent export partner. Documentation, packaging and logistics are always handled professionally. Highly recommended for international buyers."
  },
  {
    id: 3,
    name: "Ahmed Al Fahim",

    country: "United Arab Emirates",
    flag: "🇦🇪",
    rating: 5,
    verified: true,
    review: "Their professionalism and commitment to quality make them one of our most trusted suppliers. We appreciate their consistency and customer support."
  },
  {
    id: 4,
    name: "Sophia Williams",

    country: "United Kingdom",
    flag: "🇬🇧",
    rating: 5,
    verified: true,
    review: "Reliable deliveries, premium products and responsive communication. Working with their team has been a seamless experience from start to finish."
  },
  {
    id: 5,
    name: "Michael Brown",

    country: "Australia",
    flag: "🇦🇺",
    rating: 5,
    verified: true,
    review: "Every order has arrived on time with exceptional packaging and quality. Their export process is efficient and highly dependable."
  },
  {
    id: 6,
    name: "David Wilson",

    country: "Germany",
    flag: "🇩🇪",
    rating: 5,
    verified: true,
    review: "Professional service with international standards. Their dedication to quality and customer satisfaction is truly commendable."
  }
];

export default testimonials;